export interface UploadWindowWebComponentSchema {
  path: string;
  filesSize: number;
  filesNumber: number;
  streamId: string;
  maxFilesSize: number;
}

export const START_VALIDATE_PATH = 'start-validate-path';
export const VALIDATE_PATH = 'validate-path';

export const FILE_REMOVED = 'file-removed';
export const FILE_ADDED = 'file-added';
export const MAX_FILES_NUMBER = 20; // maximum number of files per request (set in php.ini - max_file_uploads)

export const ValidateDownloadPathErrorCodes = {
  PATH_NOT_FOUND: 2,
  NOT_DIRECTORY: 3,
  ACCESS_DENIED: 5,
  NOT_ENOUGH_MEMORY: 8,
  PATH_EMPTY: 161,
  INVALID_NAME: 123,
  RELATIVE_PATH: 267,
  ACCESS_DENIED_BEST_DIR: 313,
  BAD_PROFILE: 1206,
  NOT_IMPLEMENTED: 50,
};
